import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import useAuthContext from '../../contexts/AuthContext';
import { LogoutIcon } from './customIcon';

const LogoutButtonTemplate = styled.a`
  font-family: Oswald;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  box-sizing: border-box;
  background: var(--componentBackground);
  color: var(--clientColor);
  border: 1px solid var(--componentBackground);
  border-radius: 8px;
  font-size: 13px;
  box-shadow: 1px 1px 2px rgba(12, 58, 89, 0.25);
  display: flex;
  align-items: center;
  justify-items: center;
  margin: auto;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;

  &:hover {
    background: var(--clientColor);
    color: var(--componentBackground);
  }
`;

const LogoutButton = ({ collapsed }) => {
  const { dispatchAPI } = useAuthContext();

  const { t } = useTranslation();

  const isReductScreen = useMediaQuery({ query: '(max-width: 992px)' });

  return (
    <LogoutButtonTemplate
      style={{
        width: isReductScreen || collapsed ? 34 : 132,
        height: 32,
        padding: isReductScreen || collapsed ? 0 : '0px 6px',
        marginTop: '2em'
      }}
      onClick={() => dispatchAPI('LOGOUT')}
      title={` ${t('header.menu.user.logout')}`}
    >
      <LogoutIcon />
      <span
        style={{
          display: isReductScreen || collapsed ? 'none' : 'inline-block',
          margin: 'auto'
        }}
      >
        {` ${t('header.menu.user.logout')}`}
      </span>
    </LogoutButtonTemplate>
  );
};

LogoutButton.propTypes = {
  collapsed: PropTypes.bool.isRequired
};

export { LogoutButton };
